import { Box } from "@chakra-ui/react";
import React, { useState,useEffect } from "react";
import style from "../../styles/components/artistProfile.module.css";
import ScrollContainer from "react-indiana-drag-scroll";

function ServiceImagePane({ servicesArray, onClick }) {
  const [isActive, setIsActive] = useState(servicesArray[0]?._id);
  useEffect(() => {
    setIsActive(servicesArray[0]?._id);
  }, [servicesArray[0]?._id]);

  return (
    <Box className={style.servicePaneMarginTop}>
        <Box className={style.headingAndTabsRow}>
          <ScrollContainer horizontal className={style.paneContainer}>
            {servicesArray?.map((item, index) => {
              return (
                <Box
                draggable={false}
                  onClick={() => {
                    setIsActive(item?._id), onClick(item?._id);
                  }}
                  // ml={index !== 0 && '18px'}
                  as="p"
                  key={index}
                  className={
                    isActive === item?._id
                      ? style.paneItemActive
                      : style.paneItem
                  }
                >
                  {item?.name}
                </Box>
              );
            })}
          </ScrollContainer>
        </Box>
    </Box>
  );
}

export default ServiceImagePane;
